<template>
  <div id="app">
    <head-vue v-if="isShowPc" ref="headVue"></head-vue>
    <head-wap v-if="isShowWap"></head-wap>
    <content-vue></content-vue>
    <foot-vue v-if="isShowPc"></foot-vue>
    <foot-wap v-if="isShowWap"></foot-wap>
  </div>
</template>

<script>
import headVue from "./components/head.vue";
import headWap from "./components/headWap.vue";
import contentVue from "./components/content.vue";
import footVue from "./components/foot.vue";
import footWap from "./components/footWap.vue";
export default {
  name: "app",
  components: {
    headVue,
    contentVue,
    footVue,
    headWap,
    footWap,
  },
  data() {
    return {
      isShowPc: false,
      isShowWap: false,
    };
  },
  provide() {
	  return {
			test: this.test
	  }
  },
  mounted() {
    if (
      !navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.$router.replace("/home");
      this.isShowPc = true;
      window.addEventListener('resize', function(){
        document.body.style.zoom = 1;
        document.body.style.zoom = document.body.clientWidth / 2000;
      });
    
    } else {
      this.$router.replace("/homeWap");
      this.isShowWap = true;
    }
  },
  created() {
    // 判断是微信打开还是浏览器打开
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWeixin = true;
    } else {
      this.isWeixin = false;
    }
  },
  methods: {
	  test(path) {
		  console.log('------- test --------:', path)
		  this.$refs.headVue.setIndex(path)
	  }
  }
};
</script>


<style lang="less">
#app {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
</style>
